import { BrowserRouter } from "react-router-dom";
import { AuthenticatedRoutes, UnauthenticatedRoutes } from "./Routes";
import { useIsAuthenticated } from "@azure/msal-react";
import { mergeClasses } from "@fluentui/react-components";
import { Col, Container, Row } from "react-grid-system";
import useStyleUtils from "../utilities/styles";
import AccountQuickActions from "../account/quick-actions/AccountQuickActions";
import Breadcrumbs from "../navigation/breadcrumbs/Breadcrumbs";

const App = () => {
  const style = useStyleUtils();
  const isAuthenticated = useIsAuthenticated();

  if (isAuthenticated !== true) {
    return (
      <BrowserRouter>
        <UnauthenticatedRoutes />
      </BrowserRouter>
    );
  }

  const navbarStyle = mergeClasses(style.mb3, style.alignItemsCenter);
  
  return (
    <BrowserRouter>
      <Container>
        <Row className={navbarStyle}>
          <Breadcrumbs showHome={true} />
          <Col xs="content">
            <AccountQuickActions />
          </Col>
        </Row>
        <AuthenticatedRoutes />
      </Container>
    </BrowserRouter>
  );
}

export default App;